import React, { useState } from "react";

import { FlexDiv } from "../../../../Atoms";
import ModalMotion, { AnimateDirection } from "../../../../Molecules/ModalMotion";
import { TextInput } from "../../../FormInputs";

import { Label, StartDateWrapper, StyledSubmitButton } from "../style";

function Modal({ onClose, startDate, setStartDate }) {
  const [selectedDate, setSelectedDate] = useState(startDate);

  return (
    <ModalMotion
      overlayClosable={true}
      onClose={onClose}
      width="350px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      // btnPos={btnPos}
      bodyPadding={"40px"}
    >
      <StartDateWrapper className="date-picker" id="nutrition-start-date">
        <Label variant="paragraph3">Pick your package start date</Label>
        <TextInput
          placeholder="Select Start Date"
          name="startDate"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          required
          variant="v1"
          hideCalenderIcon
          iconPlacement="right"
          icon="icon-CalendarBlank"
          inputPadding="4px 16px"
          inputMarginBottom="32px"
        />
      </StartDateWrapper>
      <FlexDiv>
        <StyledSubmitButton
          id="nutrition-package-pay-now-button"
          onClick={() => {
            setStartDate(selectedDate);
            onClose();
          }}
        >
          Confirm
        </StyledSubmitButton>
      </FlexDiv>
    </ModalMotion>
  );
}

export default Modal;
